import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { formatAmountValue } from '~/common/helper';

const ProductCardPrice = ({ product }) => {
	const { t } = useTranslation();

	return (
		<div className="price-info">
			{product.priceBD ? (
				<>
					<span className="price" style={{ color: 'red' }}>
						{formatAmountValue(product.price)}
					</span>
					<span className="price-before">
						{t('product_price_suggested_retail')} {formatAmountValue(product.priceBD)}
					</span>
				</>
			) : (
				<>
					<span className="price">{formatAmountValue(product.price)}</span>
					<span className="price-before">
						{t('product_price_original')} {formatAmountValue(product.price)}
					</span>
				</>
			)}
		</div>
	);
};

ProductCardPrice.propTypes = {
	product: PropTypes.object
};
export default ProductCardPrice;
